import React from 'react';
import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, Filler } from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, Filler);

const LineChart = () => {
  const data = {
    labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    datasets: [
      {
        label: 'Profit (Lacs)',
        data: [10, 15, 12, 18, 22, 30, 28, 35, 40, 38, 42, 45],
        borderColor: 'rgba(0, 128, 255, 1)',
        backgroundColor: (context) => {
          const chart = context.chart;
          const { ctx, chartArea } = chart;
          if (!chartArea) return;
          const gradient = ctx.createLinearGradient(0, chartArea.bottom, 0, chartArea.top);
          gradient.addColorStop(0, 'rgba(0, 128, 255, 0.3)');
          gradient.addColorStop(1, 'rgba(0, 128, 255, 0.8)');
          return gradient;
        },
        pointBackgroundColor: 'rgba(0, 128, 255, 1)',
        pointHoverRadius: 8,
        pointHoverBackgroundColor: 'rgba(0, 128, 255, 1)',
        borderWidth: 2,
        fill: true,
        tension: 0.4,
      },
      {
        label: 'Expenses (Lacs)',
        data: [8, 10, 14, 16, 18, 25, 24, 30, 32, 35, 38, 40],
        borderColor: 'rgba(255, 99, 132, 1)',
        backgroundColor: (context) => {
          const chart = context.chart;
          const { ctx, chartArea } = chart;
          if (!chartArea) return;
          const gradient = ctx.createLinearGradient(0, chartArea.bottom, 0, chartArea.top);
          gradient.addColorStop(0, 'rgba(255, 99, 132, 0.3)');
          gradient.addColorStop(1, 'rgba(255, 99, 132, 0.8)');
          return gradient;
        },
        pointBackgroundColor: 'rgba(255, 99, 132, 1)',
        pointHoverRadius: 8,
        pointHoverBackgroundColor: 'rgba(255, 99, 132, 1)',
        borderWidth: 2,
        fill: true,
        tension: 0.4,
      },
    ],
  };

  const options = {
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          callback: function(value) {
            return value + 'L'; // Appending 'L' for Lacs
          },
          font: {
            size: 14,
            family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
          },
        },
        grid: {
          color: 'rgba(200, 200, 200, 0.2)',
        },
      },
      x: {
        grid: {
          color: 'rgba(200, 200, 200, 0.2)',
        },
      },
    },
    plugins: {
      legend: {
        display: true,
        position: 'top',
        labels: {
          font: {
            size: 14,
            family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
          },
          boxWidth: 20,
        },
      },
      tooltip: {
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        titleFont: {
          size: 14,
          family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
        },
        bodyFont: {
          size: 12,
          family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
        },
        callbacks: {
          label: function(context) {
            let value = context.raw;
            return context.dataset.label + ': ' + value.toLocaleString() + 'L';
          },
        },
        boxPadding: 10,
      },
    },
    layout: {
      padding: {
        top: 20,
        left: 10,
        right: 10,
        bottom: 0,
      },
    },
    responsive: true,
    maintainAspectRatio: false,
  };

  return <div style={{ height: '400px' }}><Line data={data} options={options} /></div>;
};

export default LineChart;
